import { Reducer } from '@reduxjs/toolkit';
import { JsonObj } from '@mhp/general-interface';
import { Action, MhpDetails } from 'modules/types/common';
import { FetchingReducerState } from 'store/setLocalStore';

interface ServiceConfiguration {
  authorizationEndpoint: string;
  tokenEndpoint: string;
  revocationEndpoint?: string;
  registrationEndpoint?: string;
  endSessionEndpoint?: string;
}

export type AuthConfiguration = {
  serviceConfiguration: ServiceConfiguration;
  clientId: string;
  clientSecret?: string;
  scopes: string[];
  redirectUrl: string;
  clientAuthMethod?: 'basic' | 'post';
};

export interface AuthLiteRequest {
  scope: string;
  eventId: string;
  lastName: string;
  dob: string;
  zipCode?: string;
}

export interface AuthLiteResponse {
  accessToken: string;
  consumerId: string;
  dfdEventId: string;
  personId: string;
  clinicalEventId: string;
  detailsEndpoint?: string;
  mhpDetails?: MhpDetails;
}

export type AuthLiteState = FetchingReducerState<AuthLiteResponse>;

export type AuthLiteReducer = Reducer<AuthLiteState, Action>;

export interface AuthorizeResult {
  accessToken: string;
  accessTokenExpirationDate: string;
  authorizeAdditionalParameters?: { [name: string]: string };
  tokenAdditionalParameters?: { [name: string]: string };
  idToken: string;
  refreshToken: string;
  tokenType: string;
  scopes: string[];
  authorizationCode: string;
  codeVerifier?: string;
}

export enum AuthType {
  FULL = 'Full',
  LIGHT = 'Light',
  UNAUTHENTICATED = 'unauthenticated'
}

export enum LoginType {
  PASSWORD = 'password',
  STORED_AUTH = 'stored auth'
}

export interface RefreshResultRaw {
  access_token: string;
  expires_in: number;
  additional_parameters?: { [name: string]: string };
  id_token?: string;
  refresh_token?: string | null;
  token_type: string;
}

export interface RefreshResult {
  accessToken: string;
  accessTokenExpirationDate: string;
  additionalParameters?: { [name: string]: string };
  idToken?: string;
  refreshToken?: string | null;
  tokenType: string;
}

export interface UserSession {
  accessToken: string;
  accessTokenExpirationDate: string;
  authorizeAdditionalParameters: JsonObj;
  tokenAdditionalParameters: JsonObj;
  additionalParameters: JsonObj;
  idToken: string;
  refreshToken: string;
  tokenType: string;
}

export interface OAuth2Response {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  token_type: string;
  scopes: string;
}
